import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface Respuestadehttp{
  status: string;
  resultadofinal: string;
}

@Injectable({
  providedIn: 'root'
})
export class ServiMailsService {
  infoparaelmail;

  dataParaPHP = {parametro1:'', parametro2:'', parametro3:'', parametro4:{} };

  constructor(private http: HttpClient) { }

  mandamailproveedores(servicio,to, subject, body, datos){
    this.dataParaPHP.parametro1 = to;
    this.dataParaPHP.parametro2 = subject;
    this.dataParaPHP.parametro3 = body;
    this.dataParaPHP.parametro4 = datos; 


    console.warn("Mails notificados: "+to)

    this.httpPost(servicio, ()=>{
    
    });
  }

  httpPost(servicio, callback){

    if(servicio == 'nuevopedido'){

      const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-notifica-nuevo-pedido.php',this.dataParaPHP)
     // const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-notifica-nuevo-pedido.php',this.dataParaPHP)
     
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }else
    
    if(servicio == 'nuevopedidoConQuimicos'){
     const req = this.http.post<Respuestadehttp>('https://gt-logis.com/gt-transport-api/api-notifica-nuevo-pedido-quimicos.php',this.dataParaPHP)
     // const req = this.http.post<Respuestadehttp>('https://diavisual.com/gtrans-mail-api-temp/api-notifica-nuevo-pedido-quimicos.php',this.dataParaPHP)
     
      .subscribe(
        res => {
          console.log(res.status);
          if(res.status == 'ok'){
            console.log("Resultado: OK");
            callback()
          }
          else if (res.status !='ok'){
           console.log("ERROR en php");
           callback()
          }
          
        },
        err => {
          console.log("Error occured");
          callback()
        }
      );
    }
    

    
 
}



}//fin de clase
